import React from 'react'

const ArrowLeftIcon: React.FC = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.00508 8.00499C3.81761 7.81746 3.71229 7.56316 3.71229 7.29799C3.71229 7.03283 3.81761 6.77852 4.00508 6.59099L8.59808 1.99799C8.78437 1.81543 9.03518 1.71376 9.29601 1.71508C9.55684 1.71639 9.80661 1.82059 9.99104 2.00503C10.1755 2.18946 10.2797 2.43923 10.281 2.70006C10.2823 2.96089 10.1806 3.2117 9.99808 3.39799L6.09808 7.29799L9.99808 11.198C10.1806 11.3843 10.2823 11.6351 10.281 11.8959C10.2797 12.1567 10.1755 12.4065 9.99104 12.591C9.80661 12.7754 9.55683 12.8796 9.29601 12.8809C9.03518 12.8822 8.78437 12.7806 8.59808 12.598L4.00508 8.00499Z"
      fill="#303136"
    />
  </svg>
)

export default ArrowLeftIcon
